<template>
    <div>
        <div class="row">
            <div class="col-12 col-md-4">
                <div class="form-group">                                       
                    <input type="text" class="form-control" placeholder="Buy Price" v-model="buy" maxlength=10  v-if="calculatorType =='equity'">
                    <input type="text" class="form-control" placeholder="Buy Price" v-model="fobuy" maxlength=10  v-if="calculatorType =='fo'">
                    <input type="text" class="form-control" placeholder="Buy Price" v-model="cdsbuy" maxlength=10  v-if="calculatorType =='cds'">
                    <input type="text" class="form-control" placeholder="Buy Price" v-model="mcxbuy" maxlength=10  v-if="calculatorType =='mcx'">
                </div>
            </div>
            <div class="col-12 col-md-4">
                <div class="form-group">                    
                    <input type="text" class="form-control" placeholder="Sell Price" v-model="sell" maxlength=10 v-if="calculatorType =='equity'">
                    <input type="text" class="form-control" placeholder="Sell Price" v-model="fosell" maxlength=10 v-if="calculatorType =='fo'">
                    <input type="text" class="form-control" placeholder="Sell Price" v-model="cdssell" maxlength=10 v-if="calculatorType =='cds'">
                    <input type="text" class="form-control" placeholder="Sell Price" v-model="mcxsell" maxlength=10 v-if="calculatorType =='mcx'">
                </div>
            </div>
            <div class="col-12 col-md-4">
                <div class="form-group">                    
                    <input type="text" class="form-control" placeholder="Quantity" v-model="quantity" maxlength=10 v-if="calculatorType =='equity'">
                    <input type="text" class="form-control" placeholder="Quantity" v-model="foquantity" maxlength=10 v-if="calculatorType =='fo'">
                    <input type="text" class="form-control" placeholder="Quantity" v-model="cdsquantity" maxlength=10 v-if="calculatorType =='cds'">
                    <input type="text" class="form-control" placeholder="Quantity" v-model="mcxquantity" maxlength=10 v-if="calculatorType =='mcx'">
                </div>
                <small class="text-left">Calculating tax rates applicable in</small>
            </div>
        </div>  
        <!-- <h3 class="mt-3 mb-4 text-center" v-if="calculatorType != 'mcx'">Intraday Equity</h3> -->
        <div class="customcheckbox text-center mb-3" v-if="calculatorType != 'mcx'">            
            <!-- EQUITY -->
            <label class="form-check-label" for="equitynse" v-if="calculatorType == 'equity'">                
                <input class="form-check-input" type="radio" v-model="equitytradingtype" id="equitynse" value="1">
                <span class="checkmark"></span> NSE
            </label>            
            <label class="form-check-label" for="equitybse" v-if="calculatorType == 'equity'">                                
                <input class="form-check-input" type="radio" v-model="equitytradingtype" id="equitybse" value="2">
                <span class="checkmark"></span> BSE
            </label>
            <!-- FO -->
            <label class="form-check-label" for="fonse" v-if="calculatorType == 'fo'">                                
                <input class="form-check-input" type="radio" v-model="fotradingtype" id="fonse" value="1">                
                <span class="checkmark"></span> NSE
            </label>            
            <label class="form-check-label" for="fobse" v-if="calculatorType == 'fo'">                                                
                <input class="form-check-input" type="radio" v-model="fotradingtype" id="fobse" value="2">                
                <span class="checkmark"></span> BSE
            </label>
            <!-- CDS -->
            <label class="form-check-label" for="cdsnse" v-if="calculatorType == 'cds'">                                
                <input class="form-check-input" type="radio" v-model="cdstradingtype" id="cdsnse" value="1">
                <span class="checkmark"></span> NSE
            </label>            
            <label class="form-check-label" for="cdsbse" v-if="calculatorType == 'cds'">                                                
                <input class="form-check-input" type="radio" v-model="cdstradingtype" id="cdsbse" value="2">
                <span class="checkmark"></span> BSE
            </label>
        </div>
        <div class="text-center form-group">
            <button type="button" class="fin_btn" v-on:click = "calculateInfo();">Calculate Now</button>
        </div>
        <div class="calc_table customMargin">
            <table class="table" width="100%">
                <tr>
                    <td>Turnover</td>
                    <td v-html="turnOver">0.00</td>
                </tr>
                <!-- <tr>
                    <td>Brokerage</td>
                    <td v-html="brokerage">0.00</td>
                </tr> -->
                <tr>
                    <td>Brokerage</td>
                    <td  v-html="operationalCost">0.00</td>
                </tr>
                <tr>
                    <td v-if="calculatorType == 'mcx'">CTT</td>

                    <td v-else>STT</td>
                    <td v-html="stttotal">0.00</td>
                </tr>
                <tr>
                    <td>Transaction Charges</td>
                    <td v-html="totalTranCharge">0.00</td>
                </tr>
                <tr>
                    <td>Other Charges</td>
                    <td v-html="othercharges">0.00</td>
                </tr>
                <tr>
                    <td>Clearing Charges</td>
                    <td v-html="clearingCharges">0.00</td>
                </tr>
                <tr>
                    <td>GST</td>
                    <td v-html="servicetax">0.00</td>
                </tr>
                <tr>
                    <td>SEBI Fees</td>
                    <td v-html="sebifees">0.00</td>
                </tr>
                <tr>
                    <td>Total cost of trade</td>
                    <td v-html="totalCost">0.00</td>
                </tr>
                <tr class="lastChild">
                    <td>Points to Breakeven</td>
                    <td v-html="breakeven">0.00</td>
                </tr>
            </table>     
        </div>        
    </div>
</template>
<script>     
    export default {                
        data(){
            return {                                
                "buy":"",
                "fobuy" : "",
                "cdsbuy" : "",
                "mcxbuy" : "",
                "sell":"",                            
                "fosell" : "",
                "cdssell" : "",
                "mcxsell" : "",
                "quantity": "",
                "foquantity" : "",
                "cdsquantity" : "",
                "mcxquantity" : "",
                "equitytradingtype" : "1",             
                "fotradingtype" : "1",             
                "cdstradingtype" : "1",             
                "turnOver" : "0.00", 
                "brokerage" : "0.00", 
                "stttotal" : "0.00", 
                "totalTranCharge" : "0.00", 
                "othercharges" : "0.00", 
                "clearingCharges" : "0.00",
                "servicetax" : "0.00",
                "stampduty" : "0.00",
                "sebifees" : "0.00", 
                "totalCost" : "0.00", 
                "breakeven" : "0.00",
                "operationalCost" : "0.00",
            }
        },
        props: ["calculatorType", "operationType"],        
        computed: {
                      
        },
        methods: {                        

            calculateInfo: function(){    
                this.calculationClear()
                if(this.calculatorType == "equity" && this.operationType == "equity"){
                    this.intradayEquity()
                }else if(this.calculatorType == "equity" && this.operationType == "delivery"){                    
                    this.deliveryEquity()                    
                }else if(this.calculatorType == "fo" && this.operationType == "futures"){                    
                    this.FANDOFutures()                    
                }else if(this.calculatorType == "fo" && this.operationType == "options"){                    
                    this.FANDOOptions()                    
                }else if(this.calculatorType == "cds" && this.operationType == "futures"){                    
                    this.currencyFuture()                    
                }else if(this.calculatorType == "cds" && this.operationType == "options"){                    
                    this.currencyOptions()                    
                }else if(this.calculatorType == "mcx" && this.operationType == "mcx"){                    
                    this.commodityMcx()                    
                }else if(this.calculatorType == "mcx" && this.operationType == "options"){                    
                    this.commodityOptions()                    
                }
            },
            
            calculationClear: function(){    
                this.turnOver, 
                this.brokerage, 
                this.stttotal, 
                this.totalTranCharge, 
                this.othercharges, 
                this.clearingCharges, 
                this.servicetax, 
                this.stampduty, 
                this.sebifees, 
                this.totalCost, 
                this.operationalCost,
                this.breakeven = "0.00"
            },

            intradayEquity: function(){                                          

                let equitybuyVal = this.buy;
                let equitysellVal = this.sell;
                let equityquantityVal = this.quantity;
                
                if(isNaN(equitybuyVal)){equitybuyVal = 0;}
                if(isNaN(equitysellVal)){equitysellVal = 0}
                if(isNaN(equityquantityVal)){equityquantityVal = 0;}                            
                
                if(typeof  this.equitytradingtype != 'undefined' && this.equitytradingtype == 1){    // NSE          
                    this.turnOver = parseFloat(equitybuyVal * equityquantityVal + equitysellVal * equityquantityVal).toFixed(2);
                    this.brokerage = "0.00";     
                    let buyCost = equitybuyVal.trim() == "" ? '0.00' : equitybuyVal;
                    let sellCost = equitysellVal.trim() == "" ? '0.00' : equitysellVal;
                    let x = Math.min(5, ((parseFloat(buyCost) * parseFloat(equityquantityVal)) * 0.0003));
                    let y = Math.min(5,((parseFloat(sellCost) * parseFloat(equityquantityVal)) * 0.0003));
                    this.operationalCost = parseFloat(x + y).toFixed(2);
                    this.stttotal = parseFloat((equitysellVal * equityquantityVal)*(0.025/100)).toFixed(2)           
                    this.totalTranCharge = parseFloat((this.turnOver) * (0.00297 / 100)).toFixed(2);
                    this.othercharges = "0.00";            
                    this.clearingCharges = "0.00";
                    this.totalTranCharge = parseFloat(this.turnOver * (0.00297 / 100)).toFixed(2);
                    this.stampduty = "0.00";
                    this.sebifees = parseFloat(this.turnOver * (10/10000000)).toFixed(2);
                    this.servicetax = parseFloat((parseFloat(this.totalTranCharge) + parseFloat(this.operationalCost) + parseFloat(this.sebifees)) * (18 / 100)).toFixed(2);
                    this.totalCost = parseFloat(parseFloat(this.stttotal) + parseFloat(this.totalTranCharge) + parseFloat(this.othercharges) + parseFloat(this.clearingCharges) + parseFloat(this.servicetax) + parseFloat(this.stampduty) + parseFloat(this.sebifees) + parseFloat(this.operationalCost)).toFixed(2);
                    this.breakeven = parseFloat(parseFloat(this.totalCost) / parseFloat(equityquantityVal)).toFixed(2);
                    
                }else{              
                    this.turnOver = parseFloat((equitybuyVal * equityquantityVal) + (equitysellVal * equityquantityVal)).toFixed(2);
                    this.brokerage = "0.00"; 
                    let buyCost = equitybuyVal.trim() == "" ? '0.00' : equitybuyVal;
                    let sellCost = equitysellVal.trim() == "" ? '0.00' : equitysellVal;
                    let x = Math.min(5, ((parseFloat(buyCost) * parseFloat(equityquantityVal)) * 0.0003));
                    let y = Math.min(5,((parseFloat(sellCost) * parseFloat(equityquantityVal)) * 0.0003));
                    this.operationalCost = parseFloat(x + y).toFixed(2); 
                    this.stttotal = parseFloat((equitysellVal * equityquantityVal)*(0.025/100)).toFixed(2)           
                    this.totalTranCharge = parseFloat((this.turnOver) * (0.00375 / 100)).toFixed(2);
                    this.othercharges = "0.00";            
                    this.clearingCharges = "0.00";
                    this.stampduty = 0;
                    this.sebifees = parseFloat(this.turnOver * (10/10000000)).toFixed(2);
                    this.servicetax = parseFloat((parseFloat(this.totalTranCharge) + parseFloat(this.operationalCost) + parseFloat(this.sebifees)) * (18 / 100)).toFixed(2);
                    this.totalCost = parseFloat(parseFloat(this.stttotal) + parseFloat(this.totalTranCharge) + parseFloat(this.othercharges) + parseFloat(this.clearingCharges) + parseFloat(this.servicetax) + parseFloat(this.stampduty) + parseFloat(this.sebifees) + parseFloat(this.operationalCost)).toFixed(2);
                    this.breakeven = parseFloat(parseFloat(this.totalCost) / parseFloat(equityquantityVal)).toFixed(2);           
                }
               
            },

            deliveryEquity: function(){                           

                var deliverybuyVal =this.buy
                var deliverysellVal = this.sell
                var deliveryquantityVal = this.quantity

                if(isNaN(deliverybuyVal)){deliverybuyVal = 0.00;}
                if(isNaN(deliverysellVal)){deliverysellVal = 0.00}
                if(isNaN(deliveryquantityVal)){deliveryquantityVal = 0.00;} 

                if(typeof  this.equitytradingtype != 'undefined' && this.equitytradingtype == 1){    // NSE          
                    this.turnOver = parseFloat(deliverybuyVal * deliveryquantityVal + (deliverysellVal * deliveryquantityVal)).toFixed(2);
                    this.brokerage = "0.00";   
                    this.operationalCost = "0.00";           
                    this.stttotal = parseFloat(((deliverysellVal * deliveryquantityVal) * (0.1/100)) + ((deliverybuyVal * deliveryquantityVal) * (0.1/100))).toFixed(2);
                    this.totalTranCharge = parseFloat((this.turnOver) * (0.00297 / 100)).toFixed(2);
                    this.othercharges = "0.00";            
                    this.clearingCharges = "0.00";
                    this.stampduty = "0.00";
                    this.sebifees = parseFloat(this.turnOver *(10/10000000)).toFixed(2);
                    this.servicetax = parseFloat((parseFloat(this.totalTranCharge) + parseFloat(this.operationalCost) + parseFloat(this.sebifees)) * (18 / 100)).toFixed(2);
                    this.totalCost = parseFloat(parseFloat(this.stttotal) + parseFloat(this.totalTranCharge) + parseFloat(this.othercharges) + parseFloat(this.clearingCharges) + parseFloat(this.servicetax) + parseFloat(this.stampduty) + parseFloat(this.sebifees) + parseFloat(this.operationalCost)).toFixed(2);
                    this.breakeven = parseFloat(parseFloat(this.totalCost) / parseFloat(deliveryquantityVal)).toFixed(2);             
                }else{              
                    this.turnOver = parseFloat(deliverybuyVal * deliveryquantityVal + (deliverysellVal * deliveryquantityVal)).toFixed(2);
                    this.brokerage = "0.00";     
                    this.operationalCost = "0.00";           
                    this.stttotal = parseFloat(((deliverysellVal * deliveryquantityVal) * (0.1/100)) + ((deliverybuyVal * deliveryquantityVal) * (0.1/100))).toFixed(2);                 
                    this.totalTranCharge = parseFloat((this.turnOver) * (0.00375 / 100)).toFixed(2);
                    this.othercharges = "0.00";            
                    this.clearingCharges = "0.00";
                    this.stampduty = "0.00";
                    this.sebifees = parseFloat(this.turnOver *(10/10000000)).toFixed(2);
                    this.servicetax = parseFloat((parseFloat(this.totalTranCharge) + parseFloat(this.operationalCost) + parseFloat(this.sebifees)) * (18 / 100)).toFixed(2);
                    this.totalCost = parseFloat(parseFloat(this.stttotal) + parseFloat(this.totalTranCharge) + parseFloat(this.othercharges) + parseFloat(this.clearingCharges) + parseFloat(this.servicetax) + parseFloat(this.stampduty) + parseFloat(this.sebifees) + parseFloat(this.operationalCost)).toFixed(2);
                    this.breakeven = parseFloat(parseFloat(this.totalCost) / parseFloat(deliveryquantityVal)).toFixed(2);                 
                }
            },

            FANDOFutures: function(){                           

                var fFuturesbuyVal = this.fobuy
                var fFuturessellVal = this.fosell
                var fFuturesquantityVal = this.foquantity
                
                if(isNaN(fFuturesbuyVal)){fFuturesbuyVal = 0;}
                if(isNaN(fFuturessellVal)){fFuturessellVal = 0}
                if(isNaN(fFuturesquantityVal)){fFuturesquantityVal = 0;}            
                
                
                if(typeof  this.fotradingtype != 'undefined' && this.fotradingtype == 1){    // NSE          
                    this.turnOver = parseFloat((fFuturesbuyVal * fFuturesquantityVal) + (fFuturessellVal * fFuturesquantityVal)).toFixed(2);
                    this.brokerage = "0.00";
                    let buyCost = fFuturesbuyVal.trim() == "" ? '0.00' : fFuturesbuyVal;
                    let sellCost = fFuturessellVal.trim() == "" ? '0.00' : fFuturessellVal;
                    let x = Math.min(5, ((parseFloat(buyCost) * parseFloat(fFuturesquantityVal)) * 0.0003));
                    let y = Math.min(5,((parseFloat(sellCost) * parseFloat(fFuturesquantityVal)) * 0.0003));
                    this.operationalCost = parseFloat(x + y).toFixed(2); 
                    // let x = Math.min(5, ((parseFloat(fFuturesbuyVal) * parseFloat(fFuturesquantityVal)) * 0.0003));
                    // let y = Math.min(5,((parseFloat(fFuturessellVal) * parseFloat(fFuturesquantityVal)) * 0.0003));
                    this.stttotal = parseFloat((fFuturessellVal * fFuturesquantityVal) * (0.02/100)).toFixed(2)                  
                    this.totalTranCharge = parseFloat(this.turnOver * (0.00173/100)).toFixed(2); 
                    this.othercharges = "0.00";                                
                    this.clearingCharges = "0.00";
                    this.stampduty = "0.00";
                    this.sebifees = parseFloat(this.turnOver *(10/10000000)).toFixed(2);
                    this.servicetax = parseFloat((parseFloat(this.totalTranCharge) + parseFloat(this.operationalCost) + parseFloat(this.sebifees)) * (18 / 100)).toFixed(2);
                    this.totalCost = parseFloat(parseFloat(this.stttotal) + parseFloat(this.totalTranCharge) + parseFloat(this.othercharges) + parseFloat(this.clearingCharges) + parseFloat(this.servicetax) + parseFloat(this.stampduty) + parseFloat(this.sebifees) + parseFloat(this.operationalCost)).toFixed(2);
                    this.breakeven = parseFloat(parseFloat(this.totalCost) / parseFloat(fFuturesquantityVal)).toFixed(2);     
                }else{              
                    this.turnOver = parseFloat((fFuturesbuyVal * fFuturesquantityVal) +(fFuturessellVal * fFuturesquantityVal)).toFixed(2);
                    this.brokerage = "0.00";       
                    let buyCost = fFuturesbuyVal.trim() == "" ? '0.00' : fFuturesbuyVal;
                    let sellCost = fFuturessellVal.trim() == "" ? '0.00' : fFuturessellVal;
                    let x = Math.min(5, ((parseFloat(buyCost) * parseFloat(fFuturesquantityVal)) * 0.0003));
                    let y = Math.min(5,((parseFloat(sellCost) * parseFloat(fFuturesquantityVal)) * 0.0003));
                    this.operationalCost = parseFloat(x + y).toFixed(2);   
                    this.stttotal = parseFloat((fFuturessellVal * fFuturesquantityVal) * (0.02/100)).toFixed(2)                  
                    this.totalTranCharge = parseFloat(this.turnOver * (50/10000000)).toFixed(2);  //need to discuss
                    this.othercharges = "0.00";            
                    this.clearingCharges = "0.00";
                    this.stampduty = "0.00";
                    this.sebifees = parseFloat(this.turnOver *(10/10000000)).toFixed(2);
                    this.servicetax = parseFloat((parseFloat(this.totalTranCharge) + parseFloat(this.operationalCost) + parseFloat(this.sebifees)) * (18 / 100)).toFixed(2);
                    this.totalCost = parseFloat(parseFloat(this.stttotal) + parseFloat(this.totalTranCharge) + parseFloat(this.othercharges) + parseFloat(this.clearingCharges) + parseFloat(this.servicetax) + parseFloat(this.stampduty) + parseFloat(this.sebifees) + parseFloat(this.operationalCost)).toFixed(2);
                    this.breakeven = parseFloat(parseFloat(this.totalCost) / parseFloat(fFuturesquantityVal)).toFixed(2);     
                }                           
                
            },

            FANDOOptions: function(){                           

                var fOptionsbuyVal = this.fobuy
                var fOptionssellVal = this.fosell
                var fOptionsquantityVal = this.foquantity
                
                if(isNaN(fOptionsbuyVal)){fOptionsbuyVal = 0;}
                if(isNaN(fOptionssellVal)){fOptionssellVal = 0}
                if(isNaN(fOptionsquantityVal)){fOptionsquantityVal = 0;}

                if(typeof  this.fotradingtype != 'undefined' && this.fotradingtype == 1){    // NSE       
                    this.turnOver = parseFloat((fOptionsbuyVal*fOptionsquantityVal ) + (fOptionssellVal*fOptionsquantityVal)).toFixed(2);
                    this.brokerage = "0.00";
                    let buyCost = fOptionsbuyVal.trim() == "" ? '0.00' : '5.00';
                    let sellCost = fOptionssellVal.trim() == "" ? '0.00' : '5.00';
                    this.operationalCost = fOptionsquantityVal ? (parseFloat(buyCost) + parseFloat(sellCost)).toFixed(2) : '0.00';
                    this.stttotal = parseFloat((fOptionssellVal*fOptionsquantityVal) * (0.1/100)).toFixed(2)                    
                    this.totalTranCharge = parseFloat(this.turnOver * (0.03503/100)).toFixed(2);    
                    this.othercharges = "0.00";                                
                    this.clearingCharges = "0.00";
                    this.stampduty = "0.00";
                    this.sebifees = parseFloat(this.turnOver * (10/10000000)).toFixed(2);
                    this.servicetax = parseFloat((parseFloat(this.totalTranCharge) + parseFloat(this.operationalCost) + parseFloat(this.sebifees)) * (18 / 100)).toFixed(2);
                    this.totalCost = parseFloat(parseFloat(this.stttotal) + parseFloat(this.totalTranCharge) + parseFloat(this.othercharges) + parseFloat(this.clearingCharges) + parseFloat(this.servicetax) + parseFloat(this.stampduty) + parseFloat(this.sebifees) + parseFloat(this.operationalCost)).toFixed(2);
                    this.breakeven = parseFloat(parseFloat(this.totalCost) / parseFloat(fOptionsquantityVal)).toFixed(2);          
                }else{              
                    this.turnOver = parseFloat((fOptionsbuyVal*fOptionsquantityVal ) + (fOptionssellVal*fOptionsquantityVal)).toFixed(2);
                    this.brokerage = "0.00";   
                    let buyCost = fOptionsbuyVal.trim() == "" ? '0.00' : '5.00';
                    let sellCost = fOptionssellVal.trim() == "" ? '0.00' : '5.00';
                    this.operationalCost = fOptionsquantityVal ? (parseFloat(buyCost) + parseFloat(sellCost)).toFixed(2) : '0.00';
                    this.stttotal = parseFloat((fOptionssellVal*fOptionsquantityVal) * (0.1/100)).toFixed(2)                    
                    this.totalTranCharge = parseFloat(this.turnOver * (0.0325/100)).toFixed(2);  
                    this.othercharges = "0.00";            
                    this.clearingCharges = "0.00";
                    this.stampduty = "0.00";
                    this.sebifees = parseFloat(this.turnOver * (10/10000000)).toFixed(2);
                    this.servicetax = parseFloat((parseFloat(this.totalTranCharge) + parseFloat(this.operationalCost) + parseFloat(this.sebifees)) * (18 / 100)).toFixed(2);
                    this.totalCost = parseFloat(parseFloat(this.stttotal) + parseFloat(this.totalTranCharge) + parseFloat(this.othercharges) + parseFloat(this.clearingCharges) + parseFloat(this.servicetax) + parseFloat(this.stampduty) + parseFloat(this.sebifees) + parseFloat(this.operationalCost)).toFixed(2);
                    this.breakeven = parseFloat(parseFloat(this.totalCost) / parseFloat(fOptionsquantityVal) ).toFixed(2);                 
                }  
                
            },

            currencyFuture: function(){                           

                var cFuturebuyVal = this.cdsbuy
                var cFuturesellVal = this.cdssell
                var cFuturequantityVal = this.cdsquantity
                
                if(isNaN(cFuturebuyVal)){cFuturebuyVal = 0;}
                if(isNaN(cFuturesellVal)){cFuturesellVal = 0}
                if(isNaN(cFuturequantityVal)){cFuturequantityVal = 0;}
                
                if(typeof  this.cdstradingtype != 'undefined' && this.cdstradingtype == 1){    // NSE          
                    this.turnOver = parseFloat((parseFloat(cFuturebuyVal * cFuturequantityVal) + parseFloat(cFuturesellVal * cFuturequantityVal)) ).toFixed(2);
                    this.brokerage = "0.00";   
                    let buyCost = cFuturebuyVal.trim() == "" ? '0.00' : cFuturebuyVal;
                    let sellCost = cFuturesellVal.trim() == "" ? '0.00' : cFuturebuyVal;
                    let x = Math.min(5, ((parseFloat(buyCost) * parseFloat(cFuturequantityVal)) * 0.0003));
                    let y = Math.min(5,((parseFloat(sellCost) * parseFloat(cFuturequantityVal)) * 0.0003));
                    this.operationalCost = parseFloat(x + y).toFixed(2);   
                    this.stttotal = "0.00";                                        
                    this.totalTranCharge = parseFloat(this.turnOver * (0.00035/100)).toFixed(2); 
                    this.othercharges = "0.00";                                
                    this.clearingCharges = "0.00";
                    this.stampduty = 0;
                    this.sebifees = parseFloat(this.turnOver * (10/10000000)).toFixed(2);
                    this.servicetax = parseFloat((parseFloat(this.totalTranCharge) + parseFloat(this.operationalCost) + parseFloat(this.sebifees)) * (18 / 100)).toFixed(2);
                    this.totalCost = parseFloat(parseFloat(this.stttotal) + parseFloat(this.totalTranCharge) + parseFloat(this.othercharges) + parseFloat(this.clearingCharges) + parseFloat(this.servicetax) + parseFloat(this.stampduty) + parseFloat(this.sebifees) + parseFloat(this.operationalCost)).toFixed(2);
                    this.breakeven = parseFloat(parseFloat(this.totalCost) / parseFloat(cFuturequantityVal) ).toFixed(2);              
                }else{              
                    this.turnOver = parseFloat((parseFloat(cFuturebuyVal * cFuturequantityVal) + parseFloat(cFuturesellVal * cFuturequantityVal)) ).toFixed(2);
                    this.brokerage = "0.00";    
                    let buyCost = cFuturebuyVal.trim() == "" ? '0.00' : cFuturebuyVal;
                    let sellCost = cFuturesellVal.trim() == "" ? '0.00' : cFuturebuyVal;
                    let x = Math.min(5, ((parseFloat(buyCost) * parseFloat(cFuturequantityVal)) * 0.0003));
                    let y = Math.min(5,((parseFloat(sellCost) * parseFloat(cFuturequantityVal)) * 0.0003));
                    this.operationalCost = parseFloat(x + y).toFixed(2);      
                    this.stttotal = "0.00";
                    this.totalTranCharge = parseFloat(this.turnOver * (0.00045/100)).toFixed(2);  
                    this.othercharges = "0.00";                        
                    this.clearingCharges = "0.00";  
                    this.stampduty = 0;
                    this.sebifees = parseFloat(this.turnOver * (10/10000000)).toFixed(2);
                    this.servicetax = parseFloat((parseFloat(this.totalTranCharge) + parseFloat(this.operationalCost) + parseFloat(this.sebifees)) * (18 / 100)).toFixed(2);
                    this.totalCost = parseFloat(parseFloat(this.stttotal) + parseFloat(this.totalTranCharge) + parseFloat(this.othercharges) + parseFloat(this.clearingCharges) + parseFloat(this.servicetax) + parseFloat(this.stampduty) + parseFloat(this.sebifees) + parseFloat(this.operationalCost)).toFixed(2);
                    this.breakeven = parseFloat(parseFloat(this.totalCost) / parseFloat(cFuturequantityVal)).toFixed(2);              
                }                           
                
            },

            currencyOptions: function(){                           

                var cOptionsbuyVal = this.cdsbuy
                var cOptionssellVal = this.cdssell
                var cOptionsquantityVal = this.cdsquantity
                
                if(isNaN(cOptionsbuyVal)){cOptionsbuyVal = 0;}
                if(isNaN(cOptionssellVal)){cOptionssellVal = 0}
                if(isNaN(cOptionsquantityVal)){cOptionsquantityVal = 0;}
                
                if(typeof  this.cdstradingtype != 'undefined' && this.cdstradingtype == 1){    // NSE          
                    this.turnOver = parseFloat((parseFloat(cOptionsbuyVal * cOptionsquantityVal) + parseFloat(cOptionssellVal * cOptionsquantityVal)) ).toFixed(2);
                    this.brokerage = "0.00";   
                    let buyCost = cOptionsbuyVal.trim() == "" ? '0.00' : '5.00';
                    let sellCost = cOptionssellVal.trim() == "" ? '0.00' : '5.00';
                    this.operationalCost = cOptionsquantityVal ? (parseFloat(buyCost) + parseFloat(sellCost)).toFixed(2) : "0.00";      
                    this.stttotal = "0.00";
                    this.totalTranCharge = parseFloat(this.turnOver * (0.0311/100)).toFixed(2);    
                    this.othercharges = "0.00";                                
                    this.clearingCharges = "0.00";
                    this.stampduty = 0;
                    this.sebifees = parseFloat(this.turnOver * (10/10000000)).toFixed(2);
                    this.servicetax = parseFloat((parseFloat(this.totalTranCharge) + parseFloat(this.operationalCost) + parseFloat(this.sebifees)) * (18 / 100)).toFixed(2);
                    this.totalCost = parseFloat(parseFloat(this.stttotal) + parseFloat(this.totalTranCharge) + parseFloat(this.othercharges) + parseFloat(this.clearingCharges) + parseFloat(this.servicetax) + parseFloat(this.stampduty) + parseFloat(this.sebifees) + parseFloat(this.operationalCost)).toFixed(2);
                    this.breakeven = parseFloat(parseFloat(this.totalCost / (cOptionsquantityVal))).toFixed(2);                
                }else{              
                    this.turnOver = parseFloat((parseFloat(cOptionsbuyVal * cOptionsquantityVal) + parseFloat(cOptionssellVal * cOptionsquantityVal)) ).toFixed(2);
                    this.brokerage = "0.00";
                    let buyCost = cOptionsbuyVal.trim() == "" ? '0.00' : '5.00';
                    let sellCost = cOptionssellVal.trim() == "" ? '0.00' : '5.00';
                    this.operationalCost = cOptionsquantityVal ? (parseFloat(buyCost) + parseFloat(sellCost)).toFixed(2) : "0.00";            
                    this.stttotal = "0.00";
                    this.totalTranCharge = parseFloat(this.turnOver * (0.001/100)).toFixed(2);  
                    this.othercharges = "0.00";                        
                    // this.clearingCharges = parseFloat(this.turnOver * (200/10000000)).toFixed(2); l
                    this.clearingCharges = "0.00"
                    this.stampduty = 0;
                    this.sebifees = parseFloat(this.turnOver * (10/10000000)).toFixed(2);
                    this.servicetax = parseFloat((parseFloat(this.totalTranCharge) + parseFloat(this.operationalCost) + parseFloat(this.sebifees)) * (18 / 100)).toFixed(2);
                    this.totalCost = parseFloat(parseFloat(this.stttotal) + parseFloat(this.totalTranCharge) + parseFloat(this.othercharges) + parseFloat(this.clearingCharges) + parseFloat(this.servicetax) + parseFloat(this.stampduty) + parseFloat(this.sebifees) + parseFloat(this.operationalCost)).toFixed(2);         
                    this.breakeven = parseFloat(parseFloat(this.totalCost / (cOptionsquantityVal))).toFixed(2);                
                }               
                
                
            },

            commodityMcx: function(){                           
                var commodityMcxbuyVal = this.mcxbuy
                var commodityMcxsellVal = this.mcxsell
                var commodityMcxquantityVal = this.mcxquantity
                if(isNaN(commodityMcxbuyVal)){commodityMcxbuyVal = 0;}
                if(isNaN(commodityMcxsellVal)){commodityMcxsellVal = 0}
                if(isNaN(commodityMcxquantityVal)){commodityMcxquantityVal = 0;}                
                this.turnOver = parseFloat(((commodityMcxbuyVal * commodityMcxquantityVal) + (commodityMcxsellVal * commodityMcxquantityVal))).toFixed(2);       
                this.brokerage = "0.00";   
                let buyCost = commodityMcxbuyVal.trim() == "" ? '0.00' : commodityMcxbuyVal;
                let sellCost = commodityMcxsellVal.trim() == "" ? '0.00' : commodityMcxsellVal;
                let x = Math.min(5, ((parseFloat(buyCost) * parseFloat(commodityMcxquantityVal)) * 0.0003));
                let y = Math.min(5,((parseFloat(sellCost) * parseFloat(commodityMcxquantityVal)) * 0.0003));
                this.operationalCost = parseFloat(x + y).toFixed(2);  
                this.stttotal = parseFloat((commodityMcxsellVal * commodityMcxquantityVal) * (0.01/100)).toFixed(2)                  
                this.totalTranCharge = parseFloat(this.turnOver * (210/10000000)).toFixed(2); 
                this.othercharges = "0.00";            
                // this.clearingCharges = parseFloat(this.turnOver * (50/10000000)).toFixed(2);      
                this.clearingCharges = "0.00";         
                this.stampduty = 0;      
                this.sebifees = parseFloat((this.turnOver * parseFloat(10/10000000))).toFixed(2);
                this.servicetax = parseFloat((parseFloat(this.totalTranCharge) + parseFloat(this.operationalCost) + parseFloat(this.sebifees)) * (18 / 100)).toFixed(2);
                this.totalCost = parseFloat(parseFloat(this.stttotal) + parseFloat(this.totalTranCharge) + parseFloat(this.othercharges) + parseFloat(this.clearingCharges) + parseFloat(this.servicetax) + parseFloat(this.stampduty) + parseFloat(this.sebifees) + parseFloat(this.operationalCost)).toFixed(2);                     
                this.breakeven = parseFloat(parseFloat(this.totalCost / (commodityMcxquantityVal))).toFixed(2); 
            },


            commodityOptions: function(){                    
                var commodityMcxbuyVal = this.mcxbuy
                var commodityMcxsellVal = this.mcxsell
                var commodityMcxquantityVal = this.mcxquantity
                if(isNaN(commodityMcxbuyVal)){commodityMcxbuyVal = 0;}
                if(isNaN(commodityMcxsellVal)){commodityMcxsellVal = 0}
                if(isNaN(commodityMcxquantityVal)){commodityMcxquantityVal = 0;}                
                this.turnOver = parseFloat(((commodityMcxbuyVal * commodityMcxquantityVal) + (commodityMcxsellVal * commodityMcxquantityVal))).toFixed(2);       
                this.brokerage = "0.00";    
                let buyCost = commodityMcxbuyVal.trim() == "" ? '0.00' : '5.00';
                let sellCost = commodityMcxsellVal.trim() == "" ? '0.00' : '5.00';
                this.operationalCost = commodityMcxquantityVal ? (parseFloat(buyCost) + parseFloat(sellCost)).toFixed(2) : "0.00";             
                this.stttotal = parseFloat((commodityMcxsellVal * commodityMcxquantityVal) * (0.05/100)).toFixed(2)                  
                this.totalTranCharge = parseFloat(this.turnOver * (4180/10000000)).toFixed(2); 
                this.othercharges = "0.00";            
                this.clearingCharges = "0.00"; 
                // this.clearingCharges = parseFloat(this.turnOver * (50/10000000)).toFixed(2);      
                this.stampduty = 0;      
                this.sebifees = parseFloat((this.turnOver * parseFloat(10/10000000))).toFixed(2);
                this.servicetax = parseFloat((parseFloat(this.totalTranCharge) + parseFloat(this.operationalCost) + parseFloat(this.sebifees)) * (18 / 100)).toFixed(2);
                this.totalCost = parseFloat(parseFloat(this.stttotal) + parseFloat(this.totalTranCharge) + parseFloat(this.othercharges) + parseFloat(this.clearingCharges) + parseFloat(this.servicetax) + parseFloat(this.stampduty) + parseFloat(this.sebifees) + parseFloat(this.operationalCost)).toFixed(2);                     
                this.breakeven = parseFloat(parseFloat(this.totalCost / (commodityMcxquantityVal))).toFixed(2); 
            }
        },             
        created() {            
            this.calculationClear() 

        }
    }
</script>


// WEBPACK FOOTER //
// src/components/website/shared/calculators/brokerage/brokerage_inputs.vue